import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {UserDashboard} from "@bounce/shared/consumer/declarations";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {account_id: string; payment_plan_id?: string};

type Data = UserDashboard;

export const getDashboard = async (variables: Variables): Promise<Data> => {
  if (!variables.payment_plan_id) {
    // @ts-ignore
    return undefined;
  }

  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/payment_plans/dashboard/${variables.payment_plan_id}`
  );

  return result.data;
};

export const useGetDashboardQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(
    ["account", variables.account_id, "dashboard", variables.payment_plan_id],
    getDashboard,
    variables,
    {...options, staleTime: 10000}
  );
};
